import { render } from "./networkMainPage.vue?vue&type=template&id=16b3934c&scoped=true"
import script from "./networkMainPage.vue?vue&type=script&lang=js"
export * from "./networkMainPage.vue?vue&type=script&lang=js"

import "./networkMainPage.vue?vue&type=style&index=0&id=16b3934c&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b3934c"]])

export default __exports__